/* GABINS (25-10 v11) : charge sur toutes les pages (depuis le footer). */
(function () {
  if (window.__gbSite) return; window.__gbSite = 1;
  // Icone panier : ouvre le panier Moon sur place (pas de changement de page, pas d'animation de chargement).
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cc-header__cart, .cc-quick__cart');
    if (!a || typeof window.openMoonBundleCartDrawer !== 'function') return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    if (/\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var dlg = a.closest('dialog'); if (dlg && dlg.open) dlg.close();
    window.openMoonBundleCartDrawer();
  }, true);
  // 25-10 v12 : panier Moon ouvert = la page derriere ne defile plus (le header force overflow-y visible, d'ou le style en ligne).
  var lockY = null;
  // 25-10 v14 : tant que le panier est ouvert, la page derriere garde sa position (un swipe ne la fait plus remonter).
  window.addEventListener('scroll', function () { if (lockY !== null && Math.abs(window.scrollY - lockY) > 1) window.scrollTo(0, lockY); }, { passive: true });
  var lock = function (on) {
    lockY = on ? window.scrollY : null;
    [document.documentElement, document.body].forEach(function (el) {
      if (on) { el.style.setProperty('overflow', 'hidden', 'important'); el.style.setProperty('overscroll-behavior', 'none', 'important'); }
      else { el.style.removeProperty('overflow'); el.style.removeProperty('overscroll-behavior'); }
    });
  };
  var watch = function () {
    var d = document.querySelector('.moonbundle-cart-drawer');
    if (!d) return false;
    var last = false;
    var sync = function () { var on = d.classList.contains('open'); if (on !== last) { last = on; lock(on); } };
    new MutationObserver(sync).observe(d, { attributes: true, attributeFilter: ['class'] });
    sync();
    return true;
  };
  if (!watch()) {
    var tries = 0, iv = setInterval(function () { if (watch() || ++tries > 40) clearInterval(iv); }, 250);
  }
  // 25-10 v13 : Moon rouvre le panier sur la page suivante (moonbundle_cart_drawer_keep_open) -> on l'oublie quand on quitte la page.
  var forget = function () { try { sessionStorage.removeItem('moonbundle_cart_drawer_keep_open'); } catch (e) {} };
  window.addEventListener('pagehide', forget);
  window.addEventListener('beforeunload', forget);
  // 25-10 v13 : "Add to your rotation" du panier = la paire suivante glisse en douceur (comme la galerie clients).
  var lastN = null, total = 0;
  var slideUpsell = function () {
    var c = document.querySelector('.moonbundle-cart-upsell-counter');
    if (!c) return;
    var m = c.textContent.match(/(\d+)\s*\/\s*(\d+)/);
    if (!m) return;
    var n = +m[1]; total = +m[2];
    if (lastN !== null && n !== lastN) {
      var dir = (n > lastN && !(lastN === 1 && n === total)) || (lastN === total && n === 1) ? 1 : -1;
      document.querySelectorAll('.moonbundle-cart-upsell-products-wrapper > *').forEach(function (el) {
        if (el.animate) el.animate([{ transform: 'translateX(' + (dir * 55) + '%)', opacity: 0.25 }, { transform: 'none', opacity: 1 }], { duration: 460, easing: 'cubic-bezier(.22,.61,.36,1)' });
      });
    }
    lastN = n;
  };
  var watchUpsell = function () {
    var d = document.querySelector('.moonbundle-cart-drawer');
    if (!d) return false;
    new MutationObserver(slideUpsell).observe(d, { childList: true, subtree: true, characterData: true });
    return true;
  };
  if (!watchUpsell()) {
    var t2 = 0, iv2 = setInterval(function () { if (watchUpsell() || ++t2 > 40) clearInterval(iv2); }, 250);
  }
})();


/* 25-10 v11 : barre d'achat collante = "Choose Bundle" (remonte aux offres, facon Soulties) ;
   Add to bag avec une case vide = on ouvre directement le choix de la paire au lieu de ne rien faire. */
(function () {
  if (window.__gbMoon2) return; window.__gbMoon2 = 1;
  var root = document.querySelector('cc-product');
  if (!root) return;
  var box = function () { return root.querySelector('.moonbundle-box'); };
  var label = function () {
    var b = document.querySelector('[data-cc-sticky-open]');
    if (b && box() && b.textContent.trim() !== 'Choose Bundle') b.textContent = 'Choose Bundle';
  };
  label();
  new MutationObserver(label).observe(root, { childList: true, subtree: true });
  var toBundle = function () {
    var bx = box();
    if (!bx) return false;
    var t = (bx.closest('moonbundle-component') || bx).getBoundingClientRect().top + window.scrollY - 70;
    window.scrollTo({ top: Math.max(0, t), behavior: 'smooth' });
    return true;
  };
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-cc-sticky-open]') && box()) {
      e.preventDefault(); e.stopImmediatePropagation(); toBundle(); return;
    }
    var add = t.closest('[data-cc-add]');
    if (!add || !box()) return;
    var act = box().querySelector('.moonbundle-option-active');
    var cta = act && act.querySelector('.moonbundle-ai-slot-picker-cta');
    if (cta) { e.preventDefault(); e.stopImmediatePropagation(); cta.click(); }
  }, true);
})();


/* 25-10 v12 : page produit -> barre "true to size" dans l'onglet Size Guide ; clic sur les lacets du bundle -> grand apercu. */
(function () {
  if (window.__gbSite12) return; window.__gbSite12 = 1;
  var root = document.querySelector('cc-product');
  if (!root) return;
  var placeFit = function () {
    var fit = root.querySelector('.cc-fit:not(.gb-fit)');
    if (!fit || root.querySelector('.cc-fit.gb-fit')) return;
    var guide = [].slice.call(root.querySelectorAll('details.cc-accordion')).filter(function (d) {
      var s = d.querySelector('summary'); return s && /size\s*guide/i.test(s.textContent);
    })[0];
    var body = guide && guide.querySelector('.cc-accordion__content');
    if (!body) return;
    var copy = fit.cloneNode(true);
    copy.classList.add('gb-fit');
    copy.removeAttribute('data-shopify-editor-block');
    body.insertBefore(copy, body.firstChild);
  };
  placeFit();
  document.addEventListener('DOMContentLoaded', placeFit);

  var big = function (src) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=900');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=900';
  };
  var openLace = function (item) {
    var img = item.querySelector('img');
    if (!img) return;
    var name = item.querySelector('.moonbundle-upsell-title-text');
    var sel = item.querySelector('select');
    var wrap = document.createElement('div');
    wrap.className = 'gb-lace';
    wrap.setAttribute('role', 'dialog');
    wrap.innerHTML = '<div class="gb-lace__card"><button type="button" class="gb-lace__x" aria-label="Close">&times;</button>' +
      '<img class="gb-lace__img" alt=""><p class="gb-lace__name"></p><p class="gb-lace__var"></p>' +
      '<button type="button" class="gb-lace__btn">Back</button></div>';
    wrap.querySelector('img').src = big(img.currentSrc || img.src);
    wrap.querySelector('.gb-lace__name').textContent = name ? name.textContent.trim() : (img.alt || '');
    wrap.querySelector('.gb-lace__var').textContent = sel && sel.selectedIndex > -1 ? sel.options[sel.selectedIndex].text.trim() : '';
    var close = function () { wrap.classList.remove('is-open'); setTimeout(function () { wrap.remove(); }, 360); };
    wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('.gb-lace__x, .gb-lace__btn')) close(); });
    document.addEventListener('keydown', function esc(e) { if (e.key === 'Escape') { close(); document.removeEventListener('keydown', esc); } });
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-open'); }); });
  };
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.moonbundle-box .moonbundle-upsell-image-container');
    if (!hit) return;
    e.preventDefault(); e.stopImmediatePropagation();
    openLace(hit.closest('.moonbundle-upsell-item-main') || hit);
  }, true);
})();


/* 25-10 v14 : barre du bas sans prix ; nom de la paire cliquable dans l'apercu du bundle ; drapeau du pays de livraison a cote du panier. */
(function () {
  if (window.__gbSite14) return; window.__gbSite14 = 1;
  // Barre du bas : on garde le nom et la taille, le prix part (le bundle se choisit plus haut).
  var meta = document.querySelector('.cc-sticky__meta');
  if (meta) [].slice.call(meta.childNodes).forEach(function (n) { if (n.nodeType === 3) n.textContent = ''; });

  // Apercu du bundle : le nom de la paire devient un lien vers sa page (nouvel onglet, le bundle reste ouvert).
  var urls = null;
  var loadUrls = function () {
    if (urls) return urls;
    urls = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      var m = {}; (d.products || []).forEach(function (p) { m[p.title.trim().toLowerCase()] = '/products/' + p.handle; }); return m;
    }).catch(function () { return {}; });
    return urls;
  };
  new MutationObserver(function () {
    document.querySelectorAll('.gb-pick__name:not([data-gb-link])').forEach(function (el) {
      el.setAttribute('data-gb-link', '1');
      var name = el.textContent.trim();
      if (!name) return;
      loadUrls().then(function (m) {
        var u = m[name.toLowerCase()];
        if (!u || el.querySelector('a')) return;
        var a = document.createElement('a'); a.href = u; a.target = '_blank'; a.rel = 'opener'; a.textContent = name; // opener : le nouvel onglet garde la session (pas de nouveau "welcome")
        el.textContent = ''; el.appendChild(a);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  // Drapeau : pays de livraison + devise, a cote du panier. Ce n'est pas un choix de langue (le site reste en anglais).
  var cart = document.querySelector('.cc-header__cart');
  var sel = document.querySelector('select[name="country_code"]');
  if (!cart || !sel || document.querySelector('.gb-flag')) return;
  var cc = ((window.Shopify && Shopify.country) || '').toUpperCase();
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  var flag = function (code) { return 'https://flagcdn.com/w40/' + code.toLowerCase() + '.png'; };
  var countries = [].slice.call(sel.options).map(function (o) {
    var parts = o.textContent.split('|');
    return { code: o.value, name: parts[0].trim(), cur: (parts[1] || '').trim() };
  });
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'cc-header__icon gb-flag';
  btn.setAttribute('aria-label', 'Shipping country and currency');
  btn.innerHTML = '<img alt="" width="22" height="15"><span class="gb-flag__cur"></span>';
  if (cc) btn.querySelector('img').src = flag(cc); else btn.querySelector('img').remove();
  btn.querySelector('.gb-flag__cur').textContent = cur;
  cart.parentNode.insertBefore(btn, cart);
  var go = function (code) { if (window.gbGoCountry) return window.gbGoCountry(code);
    var f = document.createElement('form');
    f.method = 'post'; f.action = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'localization';
    [['form_type', 'localization'], ['utf8', '✓'], ['country_code', code], ['return_to', location.pathname + location.search.replace(/([?&])country=[^&]*&?/, '$1').replace(/[?&]$/, '')]].forEach(function (kv) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
    });
    document.body.appendChild(f); f.submit();
  };
  btn.addEventListener('click', function () {
    var wrap = document.createElement('div');
    wrap.className = 'gb-ship';
    wrap.setAttribute('role', 'dialog');
    wrap.innerHTML = '<div class="gb-ship__card"><div class="gb-ship__head"><p class="gb-ship__title">Ship to</p><button type="button" class="gb-ship__x" aria-label="Close">&times;</button></div>' +
      '<p class="gb-ship__sub">Prices and shipping update to your country.</p><input class="gb-ship__search" type="search" placeholder="Search country" autocomplete="off"><ul class="gb-ship__list"></ul></div>';
    var list = wrap.querySelector('.gb-ship__list');
    countries.forEach(function (c) {
      var li = document.createElement('li');
      li.innerHTML = '<button type="button" class="gb-ship__item"><img alt="" loading="lazy" width="22" height="15"><span></span><span></span></button>';
      var b = li.querySelector('button');
      b.querySelector('img').src = flag(c.code);
      b.children[1].textContent = c.name;
      b.children[2].textContent = c.cur;
      if (c.code === cc) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () { if (c.code === cc) close(); else go(c.code); });
      li.dataset.q = (c.name + ' ' + c.code).toLowerCase();
      list.appendChild(li);
    });
    var close = function () { wrap.classList.remove('is-open'); setTimeout(function () { wrap.remove(); }, 320); };
    wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('.gb-ship__x')) close(); });
    wrap.querySelector('.gb-ship__search').addEventListener('input', function (e) {
      var q = e.target.value.trim().toLowerCase();
      [].slice.call(list.children).forEach(function (li) { li.hidden = q && li.dataset.q.indexOf(q) === -1; });
    });
    document.body.appendChild(wrap);
    requestAnimationFrame(function () { requestAnimationFrame(function () { wrap.classList.add('is-open'); }); });
    var curEl = list.querySelector('[aria-current="true"]');
    if (curEl) list.scrollTop = Math.max(0, curEl.offsetTop - 120);
  });
})();

/* 25-10 v15 : bug Moon - a l'ouverture, les offres non selectionnees par defaut (Single, Duo) affichent
   "This product is no longer available." sur la paire fixe alors qu'elle est en stock, et le Duo n'ajoute
   qu'une paire. Re-declencher le select de taille remet l'etat Moon a jour (corrige l'erreur et l'ajout). */
(function () {
  var tries = new WeakMap();
  function fix() {
    document.querySelectorAll('.moonbundle-box .moonbundle-variant-error-message').forEach(function (m) {
      if (!m.offsetParent) return;
      var slot = m.closest('.moonbundle-multi-product-variants-container') || m.parentElement;
      if (!slot) return;
      var n = tries.get(slot) || 0;
      if (n >= 2) return; // vrai rupture : on n'insiste pas
      tries.set(slot, n + 1);
      slot.querySelectorAll('select').forEach(function (s) { s.dispatchEvent(new Event('change', { bubbles: true })); });
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(fix, 250); }
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.moonbundle-box')) soon(); }, true);
  new MutationObserver(soon).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 25-10 v16 : changement de pays fiable (formulaire du site, avec _method=put) ; premiere visite = pays du visiteur
   s'il fait partie des marches, sinon United States (USD) (l'adresse de Londres est dans le footer : ligne Warehouse). */
(function () {
  if (window.__gbSite16) return; window.__gbSite16 = 1;
  var KEY = 'gb_loc';
  var mark = function () { try { localStorage.setItem(KEY, '1'); } catch (e) {} };
  var form = function () { var s = document.querySelector('form[action*="localization"] select[name="country_code"]'); return s && s.form ? s : null; };
  var back = function () { return location.pathname + location.search.replace(/([?&])country=[^&]*&?/, '$1').replace(/[?&]$/, ''); };
  window.gbGoCountry = function (code) {
    mark();
    var s = form();
    if (s) {
      s.value = code;
      var rt = s.form.querySelector('[name="return_to"]'); if (rt) rt.value = back();
      s.form.submit();
      return;
    }
    var f = document.createElement('form');
    f.method = 'post'; f.action = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'localization';
    [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'put'], ['country_code', code], ['return_to', back()]].forEach(function (kv) {
      var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
    });
    document.body.appendChild(f); f.submit();
  };
  // Choix fait a la main dans le footer = on ne touche plus au pays.
  document.addEventListener('change', function (e) { if (e.target && e.target.name === 'country_code') mark(); }, true);
  // Premiere visite : le marche principal de la boutique est la Thailande (THB) ; on met le visiteur sur son pays s'il est vendu, sinon US.
  var done = '1';
  try { done = localStorage.getItem(KEY); } catch (e) {}
  if (!done && !/[?&]country=/.test(location.search) && !(window.Shopify && Shopify.designMode) && !navigator.webdriver) {
    mark();
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var det = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        var s = form();
        if (!s) return;
        var sold = det && det !== 'TH' && [].some.call(s.options, function (o) { return o.value === det; });
        var target = sold ? det : 'US';
        if (target !== (window.Shopify && Shopify.country)) window.gbGoCountry(target);
      }).catch(function () {});
  }
})();

/* 25-10 v17 -> 01-11 v16 : prix des offres Moon (Duo 2e -50 %, Trio 3e offerte).
   Moon affiche les cases dynamiques au prix de la paire de la page, meme quand le client choisit une paire plus chere
   ou moins chere (Dark, Jaguar) ; le panier, lui, compte le vrai prix. On affiche donc le vrai total :
   paire de la page + paires choisies a leur vrai prix (case vide = paire de la page), avec la remise de chaque case. */
(function () {
  if (window.__gbSite17) return; window.__gbSite17 = 1;
  var FACTORS = [[1], [1, 0.5], [1, 1, 0], [1, 1, 1, 0, 0]];
  var parse = function (t) {
    var m = (t || '').match(/\d[\d.,\s ]*\d|\d/);
    if (!m) return null;
    var s = m[0], dec = /[.,]\d{2}$/.test(s) ? s.charAt(s.length - 3) : '';
    var digits = s.replace(/\D/g, '');
    return { cents: dec ? +digits : +digits * 100, dec: dec, num: s, tpl: t };
  };
  var fmt = function (cents, ref) {
    var whole = String(Math.floor(cents / 100)), c = String(cents % 100);
    if (c.length < 2) c = '0' + c;
    var th = ref.dec === ',' ? '.' : ',';
    if (ref.num.indexOf(th) > -1 || whole.length > 3) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ref.dec ? th : ' ');
    return ref.tpl.replace(ref.num, ref.dec ? whole + ref.dec + c : whole);
  };
  // Le texte existant est modifie sans remplacer le noeud.
  var put = function (el, txt) {
    if (!el || el.textContent.trim() === txt.trim()) return;
    var n = el.childNodes.length === 1 && el.firstChild.nodeType === 3 ? el.firstChild : null;
    if (n) n.data = txt; else el.textContent = txt;
  };
  // Prix de chaque paire dans la devise du client (products.json renvoie les prix du marche en cours).
  var prices = null;
  var norm = function (s) { return (s || '').replace(/change/ig, '').replace(/\s+/g, ' ').trim().toLowerCase(); };
  fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products.json?limit=250')
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var m = {};
      (d.products || []).forEach(function (p) { if (p.variants && p.variants[0]) m[norm(p.title)] = Math.round(parseFloat(p.variants[0].price) * 100); });
      prices = m; run();
    }).catch(function () {});
  var slotPrice = function (item, unit) {
    if (!prices || item.querySelector('.moonbundle-ai-slot-picker-cta')) return unit;
    var tEl = item.querySelector('.moonbundle-multi-product-title, .moonbundle-mp-line-product-title');
    var title = norm(((tEl || item).innerText || '').split('\n')[0]);
    return prices[title] || unit;
  };
  var run = function () {
    document.querySelectorAll('.moonbundle-box').forEach(function (box) {
      var opts = box.querySelectorAll('.moonbundle-option');
      if (opts.length < 2 || opts.length > 4) return;
      var unit = parse((opts[0].querySelector('.moonbundle-option-single-price') || {}).textContent);
      if (!unit || !unit.cents) return;
      for (var i = 1; i < opts.length; i++) {
        var f = FACTORS[i]; if (!f) continue;
        var items = opts[i].querySelectorAll('.moonbundle-multi-product-horizontal-layout-item');
        var total = 0, full = 0;
        for (var k = 0; k < f.length; k++) {
          var p = k === 0 || !items[k] ? unit.cents : slotPrice(items[k], unit.cents);
          total += p - Math.round(p * (1 - f[k]));
          full += p;
        }
        put(opts[i].querySelector('.moonbundle-option-single-price'), fmt(total, unit));
        put(opts[i].querySelector('.moonbundle-option-old-price'), fmt(full, unit));
      }
    });
  };
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  var n = 0, iv = setInterval(function () { run(); if (++n > 60) clearInterval(iv); }, 250);
  document.addEventListener('click', function () { setTimeout(run, 50); setTimeout(run, 400); setTimeout(run, 1200); }, true);
  document.addEventListener('change', function () { setTimeout(run, 50); setTimeout(run, 400); }, true);
  run();
})();

/* 25-10 v18 : avis clients en bas des pages produit.
   - Bandeau photos : toutes les photos/videos des avis, de la plus recente a la plus ancienne ; 6 vignettes, la 6e porte "+N" seulement s'il y a vraiment N photos en plus.
   - Clic sur une photo : fenetre en mode "Review photo X of N" -> on passe d'une photo a l'autre (tous avis confondus), du plus recent au plus ancien.
   - Clic sur un avis de la liste : "Review X of N" sur TOUS les avis tries par date (plus seulement ceux affiches avant "Load more"). */
(function () {
  if (window.__gbRev18) return; window.__gbRev18 = 1;
  var LABEL = 'Review photo [i] of [n]';
  var setup = function (el) {
    if (el.__gbRev || !el.items || !el.items.length || !el.rv || !el.rvEls) return;
    el.__gbRev = 1;
    var time = function (i) { return Date.parse(i.dataset.date) || 0; };
    // Liste complete (tri + recherche en cours), pas seulement les avis deja affiches.
    el.visibleReviews = function () {
      var term = el.search ? el.search.value.trim().toLowerCase() : '';
      return [].slice.call(el.list.querySelectorAll('.cc-review')).filter(function (i) { return !term || i.textContent.toLowerCase().indexOf(term) > -1; });
    };
    var photos = [];
    el.items.slice().sort(function (a, b) { return time(b) - time(a) || a.dataset.order - b.dataset.order; }).forEach(function (it) {
      ((it.reviewData && it.reviewData.media) || []).forEach(function (m, k) { photos.push({ item: it, k: k, m: m }); });
    });
    var mode = null, filling = false;
    var els = el.rvEls;
    var showPhoto = function () {
      var p = photos[mode];
      el.rvItem = p.item;
      filling = true; el.fillReview(p.k); filling = false;
      els.counter.textContent = LABEL.replace('[i]', mode + 1).replace('[n]', photos.length);
      if (photos.length > 1) { els.mediaPrev.hidden = false; els.mediaNext.hidden = false; }
    };
    var openPhoto = function (n) {
      mode = n;
      el.__gbPhotoOpen = true;
      filling = true; el.openReview(photos[n].item, photos[n].k); filling = false;
      el.__gbPhotoOpen = false;
      if (els.hint) els.hint.hidden = true;
      showPhoto();
    };
    var origOpen = el.openReview.bind(el);
    el.openReview = function (item, mi) { if (!el.__gbPhotoOpen) mode = null; return origOpen(item, mi); };
    var origStep = el.stepReview.bind(el);
    el.stepReview = function (dir) {
      if (mode === null) return origStep(dir);
      mode = (mode + dir + photos.length) % photos.length;
      showPhoto();
    };
    var origShow = el.showMedia.bind(el);
    el.showMedia = function (i) {
      if (mode !== null && !filling) {
        var p = photos[mode], len = p.item.reviewData.media.length;
        if (i !== p.k) {
          var dir = (i === p.k + 1) ? 1 : (i === p.k - 1) ? -1 : 0;
          if (dir) mode = (mode + dir + photos.length) % photos.length;
          else {
            var j = (i + len) % len, idx = -1;
            photos.forEach(function (q, n) { if (idx < 0 && q.item === p.item && q.k === j) idx = n; });
            if (idx > -1) mode = idx;
          }
          showPhoto();
          return;
        }
      }
      return origShow(i);
    };
    // Glisser gauche/droite sur une photo seule (Moon ne le gere que s'il y a plusieurs photos dans le meme avis).
    var sx = null;
    var stage = el.rv.querySelector('.cc-rv__media');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches.length === 1 ? [e.touches[0].clientX, e.touches[0].clientY] : null; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (!sx || mode === null) return;
        var t = e.changedTouches[0], dx = t.clientX - sx[0], dy = t.clientY - sx[1];
        sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) && photos[mode].item.reviewData.media.length === 1) el.stepReview(dx < 0 ? 1 : -1);
      });
    }
    el.rv.addEventListener('close', function () { mode = null; });
    // Bandeau photos reconstruit dans le bon ordre.
    var strip = el.querySelector('.cc-reviews__media');
    if (strip && photos.length) {
      strip.innerHTML = '';
      var MAX = 6;
      photos.slice(0, MAX).forEach(function (p, n) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cc-reviews__media-item' + (p.m.type === 'video' ? ' cc-reviews__media-item--video' : '');
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = (p.item.reviewData && p.item.reviewData.author) || '';
        img.src = p.m.thumb || p.m.poster || p.m.src;
        b.appendChild(img);
        if (p.m.type === 'video') { var pl = document.createElement('span'); pl.className = 'cc-review__play'; pl.setAttribute('aria-hidden', 'true'); b.appendChild(pl); }
        if (n === MAX - 1 && photos.length > MAX) { var more = document.createElement('span'); more.className = 'cc-reviews__media-more'; more.textContent = '+' + (photos.length - MAX); b.appendChild(more); }
        b.addEventListener('click', function () { openPhoto(n); });
        strip.appendChild(b);
      });
    }
  };
  var tries = 0;
  var scan = function () { document.querySelectorAll('cc-reviews').forEach(setup); };
  var iv = setInterval(function () { scan(); if (++tries > 40) clearInterval(iv); }, 250);
  scan();
})();
